import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((_theme: Theme) => ({
  root: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 16,
  },
  actions: {
    display: "flex",
    alignItems: "center",
    gap: 14,
  },
  iconButton: {
    width: "36px !important",
    height: "36px !important",
    color: "#6E758D !important",
    padding: "0 !important",
  },
}));
